import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

type StickyToolbarProps = {
  children?: ReactNode;
};

export const StickyToolbar: FC<StickyToolbarProps> = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '16px 16px',
        gap: '16px',
        background: '#FFF',
        boxShadow: '0px -2px 9px rgba(0, 0, 0, 0.06)',
      }}
    >
      {children}
    </Box>
  );
};
